// extracted by mini-css-extract-plugin
module.exports = {"item":"ExperienceItem_item__y8CLd","company":"ExperienceItem_company__1pHRy","time":"ExperienceItem_time__ozAiC","description":"ExperienceItem_description__RGhRM"};